function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { PlayerState } from '../../player/player-state';
export var TimelinePlayerCreationHelper = /*#__PURE__*/ function() {
    "use strict";
    function TimelinePlayerCreationHelper(playerEngine, sessionPrecursor, advertBoltOns, drmBoltons) {
        _class_call_check(this, TimelinePlayerCreationHelper);
        _define_property(this, "playerEngine", void 0);
        _define_property(this, "sessionPrecursor", void 0);
        _define_property(this, "advertBoltOns", void 0);
        _define_property(this, "drmBoltons", void 0);
        _define_property(this, "playerEngineItems", void 0);
        _define_property(this, "volumeDescription", void 0);
        this.playerEngine = playerEngine;
        this.sessionPrecursor = sessionPrecursor;
        this.advertBoltOns = advertBoltOns;
        this.drmBoltons = drmBoltons;
        this.playerEngineItems = new Map();
        this.volumeDescription = {};
    }
    _create_class(TimelinePlayerCreationHelper, [
        {
            key: "createPlayerEngineItem",
            value: function createPlayerEngineItem(playoutData) {
                var _this = this;
                var _this_volumeDescription_value, _this_volumeDescription_isMuted;
                var modifiedPlayoutData = _object_spread_props(_object_spread({}, playoutData), {
                    volume: (_this_volumeDescription_value = this.volumeDescription.value) !== null && _this_volumeDescription_value !== void 0 ? _this_volumeDescription_value : playoutData.volume,
                    muted: (_this_volumeDescription_isMuted = this.volumeDescription.isMuted) !== null && _this_volumeDescription_isMuted !== void 0 ? _this_volumeDescription_isMuted : playoutData.muted
                });
                var pei = this.sessionPrecursor.createPlayerEngineItem(this.playerEngine, modifiedPlayoutData, this.advertBoltOns, this.drmBoltons);
                var id = this.getPeiId();
                this.playerEngineItems.set(id, pei);
                this.propagateVolumeChanges(pei);
                pei.onStateChanged(function(playerState) {
                    if (playerState === PlayerState.Stopped) {
                        pei.removeEventListeners(_this);
                        _this.playerEngineItems.delete(id);
                    }
                }, this);
                return pei;
            }
        },
        {
            key: "getPeiId",
            value: function getPeiId() {
                return "PEI-".concat("0000".concat(++TimelinePlayerCreationHelper.peiIdCount).slice(-4));
            }
        },
        {
            key: "propagateVolumeChanges",
            value: function propagateVolumeChanges(newPei) {
                var _this = this;
                newPei.onVolumeChanged(function(volume) {
                    if (volume !== _this.volumeDescription.value) {
                        _this.volumeDescription.value = volume;
                        Array.from(_this.playerEngineItems.values()).forEach(function(pei) {
                            if (pei !== newPei) {
                                pei.setVolume(volume);
                            }
                        });
                    }
                }, this);
                newPei.onMuteChanged(function(isMuted) {
                    if (isMuted !== _this.volumeDescription.isMuted) {
                        _this.volumeDescription.isMuted = isMuted;
                        Array.from(_this.playerEngineItems.values()).forEach(function(pei) {
                            if (pei !== newPei) {
                                pei.setMute(isMuted);
                            }
                        });
                    }
                }, this);
            }
        }
    ]);
    return TimelinePlayerCreationHelper;
}();
_define_property(TimelinePlayerCreationHelper, "peiIdCount", 0);

//# sourceMappingURL=timeline-player-creation-helper.js.map